import type { ReactNode } from "react";
import { PackageX } from "lucide-react";

import { EmptyState } from "../components/common/EmptyState";
import { useEnabledModules } from "./useEnabledModules";

export interface ModuleGateProps {
  moduleKey: string;
  children: ReactNode;
}

/** A full page in the shell — never a 404, never an empty grid. */
export function ModuleNotAvailable() {
  return (
    <main className="p-lg">
      <EmptyState
        icon={PackageX}
        variant="error"
        title="This screen is not available on this tenant"
        body="The module that provides this screen is not enabled here."
      />
    </main>
  );
}

export function ModuleGate({ moduleKey, children }: ModuleGateProps) {
  const enabled = useEnabledModules();
  if (!enabled.some((m) => m.key === moduleKey)) return <ModuleNotAvailable />;
  return <>{children}</>;
}
